<script>
import Cookies from "js-cookie";
import {notificationMethods, customerMethods, lmsCreateUserMethods} from "@/state/helpers";
import { required, email } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import api from "@/helpers/axios";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      backFromDetail: false,
      sites: [],
      selectedSite: "",
      selectedCustomer: {},
      //
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      currentUser:JSON.parse(Cookies.get('user')),
      customers: [],
      title: "Müşteriler Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Müşteriler",
        },
      ],
      filterOpen:false,
      filters: {
        q:'',
        _site: '',
      },
      filtersDisplay: [
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      showUserModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal:false,
      formError:'',
      editFormError:'',
      sitesLoaded: false,
      addForm: {
        name: "",
        tcNumber:"",
        university:"",
        section:"",
        class:"",
        studentNumber:"",
        address:"",
        familyAddress:"",
        phone1:"",
        phone2:"",
        familyPhone:"",
        email: "",
        fatherName:"",
        motherName:"",
        birthdate:"",
        birthplace:"",
        _site: ""
      },
      editForm: {
        name: "",
        tcNumber:"",
        university:"",
        section:"",
        class:"",
        studentNumber:"",
        address:"",
        familyAddress:"",
        phone1:"",
        phone2:"",
        familyPhone:"",
        email: "",
        fatherName:"",
        motherName:"",
        birthdate:"",
        birthplace:"",
        _site:""
      },
      editId: "",
      deleteId: "",
      //
      totalRows: 1,
      page: 1,
      perPage: 10,
      search:'',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "email",
          sortable: true,
        },
        {
          key: "site.name",
          sortable: false,
        },
        /*{
          key: "createUser",
          label:'LMS',
          sortable: true,
        },*/
        {
          key: "detail",
          label: "Detay",
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput:1,
      //
      addUserForm: {
        site: "",
      },
      editUserForm: {
        site: "",
      }
    };
  },
  validations: {
    addForm: {
      name: {required},
      tcNumber:{required},
      //university:{required},
      //address:{required},
      //familyAddress:{required},
      phone1:{required},
      //phone2:{required},
      //familyPhone:{required},
      email: {required, email},
      _site: {required}
      //fatherName:{required},
      //motherName:{required},
      //birthdate:{required},
    },
    editForm: {
      name: {required},
      tcNumber:{required},
      //university:{required},
      //address:{required},
      //familyAddress:{required},
      phone1:{required},
      //phone2:{required},
      //familyPhone:{required},
      email: {required, email},
      _site: {required}
      //fatherName:{required},
      //motherName:{required},
      //birthdate:{required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    filteredSites() {
      return this.sites.filter(site => site.field === true);
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch:{
    page(newPage){
      this.pageInput=newPage;
      this.getCustomers(newPage);
    },
    search(newSearch){
      if(newSearch.length<1){
        this.filters.q = '';
        if(this.page===1){
          this.getCustomers();
        }else{
          this.page=1;
        }
      }
    },
    filters: {
      handler() {
        this.getCustomers()
      },
      deep: true
    },
    'addForm.email':function(){
      this.addForm.email= this.turkishToLower(this.addForm.email)
    },
    'editForm.email':function(){
      this.editForm.email= this.turkishToLower(this.editForm.email)
    }
  },
  mounted() {
/*    JSON.parse(localStorage.removeItem('paginationInfo'));*/
    this.fetchSites();
    if(this.$route.query.page){
      this.page = Number(this.$route.query.page)
    } else {
      this.getCustomers();
    }
    /* eslint-disable no-console */
  },
  methods: {
    badgeClass(item) {
      if (item.contract.execute) {
        return 'badge-soft-primary';
      } else if (item.contract.warning) {
        return 'badge-soft-yellow';
      } else if (item.contract.thh) {
        return 'badge-soft-warning';
      } else if (item.contract.completedStatus) {
        return 'badge-soft-info';
      } else if (!item.contract.status) {
        return 'badge-soft-danger';
      } else if (item.contract.status) {
        return 'badge-soft-success';
      } else {
        return 'badge-soft-light'; // Eğer hiçbir duruma uymuyorsa boş bir sınıf döner
      }
    },
    toggleFilter(){
      this.filterOpen =! this.filterOpen;
    },

    getSitesForFormSelect(){
      this.sitesLoaded=false;
      this.fetchSites({listType:'select'}).then(res=>{
        if(res.docs.length>0){
          this.formSelectSites = res;
        }
        this.sitesLoaded=true;
      })
    },
    navigateToDetailPage(customer) {
      const paginationInfo = {
        page: this.page,
        limit: this.perPage,
      };

// Vuex kullanılmıyorsa localStorage üzerinde pagination bilgilerini sakla
      localStorage.setItem('paginationInfo', JSON.stringify(paginationInfo));

      this.$router.push({ name: 'customerDetail', params: { customerId: customer.id } });
    },
    handleReturnFromDetailPage() {

      const paginationInfo = JSON.parse(localStorage.getItem('paginationInfo'));

// Eğer bilgiler varsa, sayfayı ve limiti güncelle
      if (paginationInfo) {
        this.$store.commit('updatePagination', paginationInfo);
      }

// Müşteri listesi sayfasına geri dön
      this.$router.push({ path: '/customers' });
    },

    filterNumbers() {
      this.addForm.tcNumber = this.addForm.tcNumber.slice(0, 11);
      this.addForm.tcNumber = this.addForm.tcNumber.replace(/[^\d0-9]/g, '');
    },
    isValidTCKN(tcNumber) {
      if (tcNumber && tcNumber.length === 11) {
        const firstDigit = parseInt(tcNumber.charAt(0), 10);
        if (
            firstDigit !== 0 &&
            tcNumber.split('').every(char => !isNaN(char)) &&
            parseInt(tcNumber.charAt(10), 10) % 2 === 0
        ) {
          return true;
        }
      }
      return false;
    },
    validateNameEdit() {
      if (this.editForm.name) {
        const isValidName = /^[A-Za-zÇçĞğİıÖöŞşÜü\s]+$/.test(this.editForm.name);
        if (!isValidName) {
          this.editForm.name = this.editForm.name.replace(/[^A-Za-z\s]+/g, '');
        }
      }
    }, validateNameAdd() {
      if (this.addForm.name) {
        const isValidName = /^[A-Za-zÇçĞğİıÖöŞşÜü\s]+$/.test(this.addForm.name);
        if (!isValidName) {
          this.addForm.name = this.addForm.name.replace(/[^A-Za-z\s]+/g, '');
        }
      }
    },
    //add phone 1
    formatPhoneNumberAddFirst() {
      if (this.addForm.phone1) {
        let formattedNumber = this.addForm.phone1.replace(/\D/g, '');
        if (formattedNumber.charAt(0) === '0') {
          formattedNumber = formattedNumber.slice(1);
        }
        if (formattedNumber.length === 10) {
          const areaCode = formattedNumber.slice(0, 3);
          const firstPart = formattedNumber.slice(3, 6);
          const secondPart = formattedNumber.slice(6, 8);
          const lastPart = formattedNumber.slice(8, 10);
          formattedNumber = `0 (${areaCode}) ${firstPart} ${secondPart} ${lastPart}`;
          this.addForm.phone1 = formattedNumber;
        } else {
          this.addForm.phone1 = '';
        }
      }
    },
    filterNumbersPhoneAddFirst() {
      this.addForm.phone1 = this.addForm.phone1.replace(/[^\d0-9]/g, '');
    },
    //edit phone 1
    formatPhoneNumberEditFirst() {
      if (this.editForm.phone1) {
        let formattedNumber = this.editForm.phone1.replace(/\D/g, '');
        if (formattedNumber.charAt(0) === '0') {
          formattedNumber = formattedNumber.slice(1);
        }
        if (formattedNumber.length === 10) {
          const areaCode = formattedNumber.slice(0, 3);
          const firstPart = formattedNumber.slice(3, 6);
          const secondPart = formattedNumber.slice(6, 8);
          const lastPart = formattedNumber.slice(8, 10);
          formattedNumber = `0 (${areaCode}) ${firstPart} ${secondPart} ${lastPart}`;
          this.editForm.phone1 = formattedNumber;
        } else {
          this.editForm.phone1 = '';
        }
      }
    },
    filterNumbersPhoneEditFirst() {
      this.editForm.phone1 = this.editForm.phone1.replace(/[^\d0-9]/g, '');
    },

    //add phone 2
    formatPhoneNumberAddSecond() {
      if (this.addForm.phone2) {
        let formattedNumber = this.addForm.phone2.replace(/\D/g, '');
        if (formattedNumber.charAt(0) === '0') {
          formattedNumber = formattedNumber.slice(1);
        }
        if (formattedNumber.length === 10) {
          const areaCode = formattedNumber.slice(0, 3);
          const firstPart = formattedNumber.slice(3, 6);
          const secondPart = formattedNumber.slice(6, 8);
          const lastPart = formattedNumber.slice(8, 10);
          formattedNumber = `0 (${areaCode}) ${firstPart} ${secondPart} ${lastPart}`;
          this.addForm.phone2 = formattedNumber;
        } else {
          this.addForm.phone2 = '';
        }
      }
    },
    filterNumbersPhoneAddSecond() {
      if(this.addForm.phone2){
        this.addForm.phone2 = this.addForm.phone2.replace(/[^\d0-9]/g, '');
      }
    },
    //edit phone 2
    formatPhoneNumberEditSecond() {
      if (this.editForm.phone2) {
        let formattedNumber = this.editForm.phone2.replace(/\D/g, '');
        if (formattedNumber.charAt(0) === '0') {
          formattedNumber = formattedNumber.slice(1);
        }
        if (formattedNumber.length === 10) {
          const areaCode = formattedNumber.slice(0, 3);
          const firstPart = formattedNumber.slice(3, 6);
          const secondPart = formattedNumber.slice(6, 8);
          const lastPart = formattedNumber.slice(8, 10);
          formattedNumber = `0 (${areaCode}) ${firstPart} ${secondPart} ${lastPart}`;
          this.editForm.phone2 = formattedNumber;
        } else {
          this.editForm.phone2 = '';
        }
      }
    },
    filterNumbersPhoneEditSecond() {
      if(this.editForm.phone2){
        this.editForm.phone2 = this.editForm.phone2.replace(/[^\d0-9]/g, '');
      }
    },


    //add family phone
    formatFamilyPhone() {
      if (this.addForm.familyPhone) {
        let formattedNumber = this.addForm.familyPhone.replace(/\D/g, '');
        if (formattedNumber.charAt(0) === '0') {
          formattedNumber = formattedNumber.slice(1);
        }
        if (formattedNumber.length === 10) {
          const areaCode = formattedNumber.slice(0, 3);
          const firstPart = formattedNumber.slice(3, 6);
          const secondPart = formattedNumber.slice(6, 8);
          const lastPart = formattedNumber.slice(8, 10);
          formattedNumber = `0 (${areaCode}) ${firstPart} ${secondPart} ${lastPart}`;
          this.addForm.familyPhone = formattedNumber;
        } else {
          this.addForm.familyPhone = '';
        }
      }
    },
    filterFamilyPhone() {
      if(this.addForm.familyPhone){
        this.addForm.familyPhone = this.addForm.familyPhone.replace(/[^\d0-9]/g, '');
      }
    },
    //edit family phone
    formatFamilyPhoneEdit() {
      if (this.editForm.familyPhone) {
        let formattedNumber = this.editForm.familyPhone.replace(/\D/g, '');
        if (formattedNumber.charAt(0) === '0') {
          formattedNumber = formattedNumber.slice(1);
        }
        if (formattedNumber.length === 10) {
          const areaCode = formattedNumber.slice(0, 3);
          const firstPart = formattedNumber.slice(3, 6);
          const secondPart = formattedNumber.slice(6, 8);
          const lastPart = formattedNumber.slice(8, 10);
          formattedNumber = `0 (${areaCode}) ${firstPart} ${secondPart} ${lastPart}`;
          this.editForm.familyPhone = formattedNumber;
        } else {
          this.editForm.familyPhone = '';
        }
      }
    },
    filterFamilyPhoneEdit() {
      if(this.editForm.familyPhon){
        this.editForm.familyPhone = this.editForm.familyPhone.replace(/[^\d0-9]/g, '');
      }
    },
    isValidPhoneNumber(phoneNumber) {
      const phoneNumberRegex = /^(05\d{9}|05\d{8}|[1-9]\d{9})$/;
      return phoneNumberRegex.test(phoneNumber);
    },
    ...customerMethods,
    ...notificationMethods,
    ...lmsCreateUserMethods,
    generateRandomPassword(length) {
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+=<>?";
      let password = "";

      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        password += charset.charAt(randomIndex);
      }

      return password;
    },
    openUserCreationModal(customer) {
      this.selectedCustomer = customer;
      this.showUserModal = true;
    },
    formatSite(site) {
      return site
    },
    async fetchSites() {
      try {
        const response = await api.get("/sites" );
        this.sites = response.data.data.docs;
      } catch (error) {
        return
      }
    },
    doSearch(){
      this.filters.q=this.search;
      if(this.page===1){
        this.getCustomers();
      }else{
        this.page=1;
      }
    },
    clearFilters(){
      this.filters._site=''
    },

    async getCustomers() {
      try {
        this.itemsLoaded = false;
        let filter={}
        // Mevcut sayfa ve filtre bilgilerini sakla
        const currentPage = this.page;
        const currentFilter = this.filter;

        // localStorage'dan pagination bilgilerini al
        const paginationInfo = JSON.parse(localStorage.getItem('paginationInfo'));

        let pageToFetch;
        if (paginationInfo && !this.backFromDetail) {
          // Eğer paginationInfo varsa ve detaydan dönüş yapılmışsa, o sayfayı getir
          pageToFetch = paginationInfo.page;

          localStorage.removeItem('paginationInfo');
        } else {
          // Eğer paginationInfo yoksa veya detaydan dönüş yapılmamışsa, varsayılan sayfa numarasını kullan
          pageToFetch = currentPage;
          this.backFromDetail = false; // Bayrağı sıfırla
        }

        // pageToFetch'i güncelle
        this.pageToFetch = this.page;
        console.log(this.filters)
        if(this.filters._site){
          filter._site = this.filters._site;
        }
        if(this.filters.q){
          filter.q = this.filters.q;
        }
        // pagination bilgilerini kullanarak customers'ı getir
        const response = await this.fetchCustomers({
          page: pageToFetch,
          limit: paginationInfo ? paginationInfo.limit : 10,
          ...filter
        });

        // getting category ready for fields
        this.items = response.docs.map(elem => {
          return elem;
        });
        this.totalRows = response.total;

        this.filter = currentFilter;

        // Toplam sayfa sayısını güncelle
        //this.totalPages = Math.ceil(this.totalRows / this.perPage);

        this.itemsLoaded = true;
      } catch (error) {
        error
      }
    },



/*    async getCustomers() {
      try {
        this.itemsLoaded = false;

        // Mevcut sayfa ve filtre bilgilerini sakla
        const currentPage = this.page;
        const currentFilter = this.filter;

        // localStorage'dan pagination bilgilerini al
        const paginationInfo = JSON.parse(localStorage.getItem('paginationInfo'));

        let pageToFetch;
        if (paginationInfo && !this.backFromDetail) {
          // Eğer paginationInfo varsa ve detaydan dönüş yapılmışsa, o sayfayı getir
          pageToFetch = paginationInfo.page;

          localStorage.removeItem('paginationInfo');
        } else {
          // Eğer paginationInfo yoksa veya detaydan dönüş yapılmamışsa, varsayılan sayfa numarasını kullan
          pageToFetch = currentPage;
          this.backFromDetail = false; // Bayrağı sıfırla
        }

        // pagination bilgilerini kullanarak customers'ı getir
        const response = await this.fetchCustomers({
          search: this.search,
          page: pageToFetch,
          limit: paginationInfo ? paginationInfo.limit : 10,
        });

        // getting category ready for fields
        this.items = response.docs.map(elem => {
          return elem;
        });
        this.totalRows = response.total;

        this.filter = currentFilter;

        // Toplam sayfa sayısını güncelle
        this.totalPages = Math.ceil(this.totalRows / this.perPage);

        this.itemsLoaded = true;
      } catch (error) {
        error;
      }
    },*/






    handleSubmit() {
      this.addSubmitted = true;
      this.formError="";
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      }  else if (!this.isValidTCKN(this.addForm.tcNumber)) {
        this.formError = "";
        return;
      }else {
        this.filterNumbersPhoneAddFirst()
        this.filterNumbersPhoneAddSecond()
        this.filterFamilyPhone()
        this.createCustomer(this.addForm).then(()=>{
          this.toastMessage="Müşteri başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.getCustomers();
          this.addForm.name = "";
          this.addForm.tcNumber = "";
          this.addForm.university = "";
          this.addForm.section = "";
          this.addForm.class = "";
          this.addForm.studentNumber = "";
          this.addForm.address = "";
          this.addForm.familyAddress = "";
          this.addForm.phone1 = "";
          this.addForm.phone2 = "";
          this.addForm.familyPhone = "";
          this.addForm.email = "";
          this.addForm.fatherName = "";
          this.addForm.motherName = "";
          this.addForm.birthdate = "";
          this.addForm.birthplace = "";
        }).catch((err)=>{
          if(err=='TCNUMBER_ALREADY_USE'){
            this.formError="Girilen TC numarasına sahip bir müşteri bulunmaktadır."
          }else{
            this.toastMessage="Sistemde bir hata oluştu!";
            this.toastAction="error";
            this.showToast=true;
            setTimeout(()=>{
              this.showToast=false;
            },3000)
          }
        })
      }
    },
    handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError=""
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else if (!this.isValidTCKN(this.editForm.tcNumber)) {
        this.formError = "";
        return;
      } else {
        this.filterNumbersPhoneEditFirst()
        this.filterNumbersPhoneEditSecond()
        this.filterFamilyPhoneEdit()
        this.updateCustomer({id:this.editId,data:this.editForm}).then(()=>{
          this.toastMessage="Müşteri başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.editModal = false;
          this.getCustomers();
        }).catch((err)=>{
          if(err=='TCNUMBER_ALREADY_USE'){
            this.editFormError="Girilen TC numarasına sahip bir müşteri bulunmaktadır."
          }else{
            this.toastMessage="Sistemde bir hata oluştu!";
            this.toastAction="error";
            this.showToast=true;
            setTimeout(()=>{
              this.showToast=false;
            },3000)
          }
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteCustomer(this.deleteId).then(()=>{
        this.deleteModal = false;
        this.toastMessage="Müşteri başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getCustomers();
      })

    },
    openEdit(customer) {
      this.editForm.name = customer.name
      this.editForm.tcNumber = customer.tcNumber
      this.editForm.university = customer.university
      this.editForm.section = customer.section
      this.editForm.class = customer.class
      this.editForm.studentNumber = customer.studentNumber
      this.editForm.address = customer.address
      this.editForm.familyAddress = customer.familyAddress
      this.editForm.phone1 = customer.phone1
      this.editForm.phone2 = customer.phone2
      this.editForm.familyPhone = customer.familyPhone
      this.editForm.email = customer.email
      this.editForm.fatherName = customer.fatherName
      this.editForm.motherName = customer.motherName
      this.editForm.birthdate = customer.birthdate ? customer.birthdate.split('T')[0] : ""
      this.editForm.birthplace = customer.birthplace
      this.editForm._site = customer._site
      this.editId = customer.id;
      this.editModal = true;
      this.formatPhoneNumberEditFirst()
      this.formatPhoneNumberEditSecond()
      this.formatFamilyPhoneEdit()
    },
    openDelete(customer) {
      if(customer.email===this.currentUser.email){
        this.noDeleteModal=true;
      }else{
        this.deleteId = customer.id;
        this.deleteModal = true;
      }
    },
    resetForm() {
      this.addForm.name = null;
      this.addForm.tcNumber = null;
      this.addForm.university = null;
      this.addForm.section = null;
      this.addForm.class = null;
      this.addForm.studentNumber = null;
      this.addForm.address = null;
      this.addForm.familyAddress = null;
      this.addForm.phone1 = null;
      this.addForm.phone2 = null;
      this.addForm.familyPhone = null;
      this.addForm.email = null;
      this.addForm.fatherName = null;
      this.addForm.motherName = null;
      this.addForm.birthdate = null;
      this.addForm.birthplace = null;
      //
      this.addSubmitted = false;
    },
    turkishToLower(str){
      let letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function(letter){ return letters[letter]; })
      return str.toLowerCase();
    },
    handleUserSubmit() {
      this.addSubmitted = true;
      this.formError = '';
      if (this.selectedSite && this.selectedCustomer) {
        const randomPassword = this.generateRandomPassword(12);
        const userData = {
          site: this.selectedSite,
          customer: this.selectedCustomer._id,
          name: this.selectedCustomer.name,
          email: this.selectedCustomer.email,
          password:randomPassword,
        };
        this.createLmsUser(userData)
            .then(() => {
              this.toastMessage = "Kullanıcı başarıyla oluşturuldu!";
              this.toastAction = "success";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);
              this.showModal = false;
              this.getCustomers();
              this.addUserForm.site = "";
            })
            .catch((err) => {
              if (err == 'TCNUMBER_ALREADY_USE') {
                this.formError = "Girilen TC numarasına sahip bir kullanıcı bulunmaktadır.";
              } else {
                this.toastMessage = "Sistemde bir hata oluştu!";
                this.toastAction = "error";
                this.showToast = true;
                setTimeout(() => {
                  this.showToast = false;
                }, 3000);
              }
            });
      } else {
        this.formError = 'Lütfen bir site seçin';
      }
    },
    onChangePage(page) {
      const { query } = this.$route;
      this.$router.push({ query: { ...query, page } });
      this.page = page
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <div @click="toggleFilter" class="d-flex align-items-center justify-content-center gap-2 py-2 px-2" :style="{border:'1px solid rgb(108, 117, 125)',borderRadius:'.2rem',cursor: 'pointer'}">
                    <i class="bx bx-filter" :style="{fontSize:'20px'}"></i>
                    Filtreler
                  </div>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Müşteri Ekle
                </button>
              </div>

              <div v-if="filterOpen" class="row py-3 my-2">
                <form @submit.prevent="" class="d-flex flex-row flex-wrap gap-4 align-items-center">
                  <div class="row align-items-center" v-for="filter in filtersDisplay" :key="filter.key">
                    <div class="col-12">
                      <div>
                        <select
                            class="form-control px-4"
                            v-model="filters[filter.key]"
                        >
                          <option value="">{{filter.name}}</option>

                          <option
                              v-for="choice in filter.choices"
                              :key="choice.key"
                              :value="choice.key"
                          >
                            {{ choice.name }}
                          </option>
                        </select>
                        <div class="arrow-down position-absolute" :style="{color:'black',right:'24px',top:'8px',pointerEvents:'none'}">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="align-items-center">
                    <select name="_site"
                            v-model="filters._site"
                            class="form-control"
                    >
                      <option value="">Siteler</option>
                      <option
                          v-for="site in sites"
                          :key="site.id"
                          :value="site.id"
                      >{{site.name}}</option>
                    </select>
                  </div>
                  <div>
                    <button
                        class="btn btn-dark"
                        @click="clearFilters"
                    >
                      Filtreleri Temizle
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(name)="data">
                    <span v-if="data.item.contract"
                        class="badge badge-pill font-size-14"
                        :class="badgeClass(data.item)">
                      {{data.item.name}}
                    </span>
                    <span v-else>
                      {{data.item.name}}
                    </span>
                  </template>
                  <template v-slot:cell(createdAt)="data">
                    {{new Date(data.item.createdAt).toDateString()}}
                  </template>
                  <template v-slot:cell(createUser)="data">
                    <button
                        :class="[data.item.canCreateUser ? 'btn btn-success' : 'btn btn-secondary', 'd-flex py-2']"
                        @click="openUserCreationModal(data.item)"
                        :disabled="!data.item.canCreateUser"
                    >
                      <i :class="`bx bxs-user bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="navigateToDetailPage(data.item)"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="onChangePage(pageInput)" v-model="pageInput" type="text"  class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        :current-page="page"
                        @change="onChangePage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showUserModal" title="Kullanıcı Oluştur" hide-footer>
        <form @submit.prevent="handleUserSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="site">Site Seçiniz</label>
                <select id="site" v-model="selectedSite" class="form-control">
                  <option value="">Site Seçiniz</option>
                  <option v-for="site in filteredSites" :key="site.id" :value="site.domain">{{ site.name }}</option>
                </select>
              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="showModal" title="Müşteri Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                    @input="validateNameAdd"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="tcNumber">TC Kimlik Numarası</label>
                <input
                    name="tcNumber"
                    id="tcNumber"
                    type="number"
                    autocomplete="off"
                    :class="{
                    'is-invalid': addSubmitted && !isValidTCKN(addForm.tcNumber)
                     }"
                    v-model="addForm.tcNumber"
                    class="form-control"
                    placeholder="TC Kimlik Numarası giriniz"
                    @input="filterNumbers"
                    maxlength="11"
                />

                <span v-if="addSubmitted && !isValidTCKN(addForm.tcNumber)" class="invalid-feedback">
      Geçerli bir TC Kimlik Numarası giriniz.
    </span>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="university">Üniversite</label>
                <input
                    id="university"
                    type="text"
                    v-model="addForm.university"
                    class="form-control"
                    placeholder="Üniversite giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="section">Bölüm</label>
                <input
                    id="section"
                    type="text"
                    v-model="addForm.section"
                    class="form-control"
                    placeholder="Bölüm giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="class">Sınıf</label>
                <input
                    id="class"
                    type="text"
                    v-model="addForm.class"
                    class="form-control"
                    placeholder="Sınıf giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="studentNumber">Öğrenci Numarası</label>
                <input
                    id="studentNumber"
                    type="text"
                    v-model="addForm.studentNumber"
                    class="form-control"
                    placeholder="Öğrenci Numarası giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="address">Adres</label>
                <input
                    id="address"
                    type="text"
                    v-model="addForm.address"
                    class="form-control"
                    placeholder="Adres giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    autocomplete="off"
                    v-model="addForm.email"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.email.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.addForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="phone1">Telefon 1</label>
                <input
                    id="phone1"
                    type="text"
                    v-model="addForm.phone1"
                    class="form-control"
                    placeholder="Telefon numarası giriniz"
                    @blur="formatPhoneNumberAddFirst"
                    @input="filterNumbersPhoneAddFirst"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.phone1.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.phone1.required"
                    class="invalid-feedback"
                >
                  Telefon 1 girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="phone2">Telefon 2</label>
                <input
                    id="phone2"
                    type="text"
                    v-model="addForm.phone2"
                    class="form-control"
                    placeholder="Telefon numarası giriniz"
                    @blur="formatPhoneNumberAddSecond"
                    @input="filterNumbersPhoneAddSecond"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="familyAddress">Aile Adresi</label>
                <input
                    id="familyAddress"
                    type="text"
                    v-model="addForm.familyAddress"
                    class="form-control"
                    placeholder="Aile Adresi giriniz"

                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="familyPhone">Aile Telefonu</label>
                <input
                    id="familyPhone"
                    type="text"
                    v-model="addForm.familyPhone"
                    class="form-control"
                    placeholder="Aile Telefonu giriniz"
                    @blur="formatFamilyPhone"
                    @input="filterFamilyPhone"
                />

              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="fatherName">Baba Adı</label>
                <input
                    name="fatherName"
                    id="fatherName"
                    type="text"
                    autocomplete="off"
                    v-model="addForm.fatherName"
                    class="form-control"
                    placeholder="Baba Adı giriniz"

                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="motherName">Anne Adı</label>
                <input
                    name="motherName"
                    id="motherName"
                    type="text"
                    autocomplete="off"
                    v-model="addForm.motherName"
                    class="form-control"
                    placeholder="Anne Adı giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="birthdate">Doğum Tarihi</label>
                <b-form-input
                    v-model="addForm.birthdate"
                    id="birthdate"
                    type="date"

                ></b-form-input>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="birthplace">Doğum Yeri</label>
                <input
                    name="birthplace"
                    id="birthplace"
                    type="text"
                    autocomplete="off"
                    v-model="addForm.birthplace"
                    class="form-control"
                    placeholder="Doğum Yeri giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="birthplace">Site Seçiniz</label>
                <select id="site" v-model="addForm._site" class="form-control" :class="{'is-invalid': addSubmitted && $v.addForm._site.$error}">
                  <option value="">Site Seçiniz</option>
                  <option v-for="site in sites" :key="site.id" :value="site.id">{{ site.name }}</option>
                </select>
              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Müşteri Ekle</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="editModal" title="Müşteri Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    :disabled="currentUser.role.includes('user')"
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    @input="validateNameEdit"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="tcNumber">TC Kimlik Numarası</label>
                <input
                    name="tcNumber"
                    id="tcNumber"
                    type="number"
                    autocomplete="off"
                    :class="{
                    'is-invalid': editForm && !isValidTCKN(editForm.tcNumber)
                     }"
                    v-model="editForm.tcNumber"
                    class="form-control"
                    placeholder="TC Kimlik Numarası giriniz"
                    @input="filterNumbersEdit"
                    maxlength="11"
                />
                <span v-if="editSubmitted && !isValidTCKN(editForm.tcNumber)" class="invalid-feedback">
      Geçerli bir TC Kimlik Numarası giriniz.
    </span>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="university">Üniversite</label>
                <input
                    id="university"
                    type="text"
                    v-model="editForm.university"
                    class="form-control"
                    placeholder="Üniversite giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="section">Bölüm</label>
                <input
                    id="section"
                    type="text"
                    v-model="editForm.section"
                    class="form-control"
                    placeholder="Bölüm giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="class">Sınıf</label>
                <input
                    id="class"
                    type="text"
                    v-model="editForm.class"
                    class="form-control"
                    placeholder="Sınıf giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="studentNumber">Öğrenci Numarası</label>
                <input
                    id="studentNumber"
                    type="text"
                    v-model="editForm.studentNumber"
                    class="form-control"
                    placeholder="Öğrenci Numarası giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="address">Adres</label>
                <input
                    id="address"
                    type="text"
                    v-model="editForm.address"
                    class="form-control"

                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    autocomplete="off"
                    v-model="editForm.email"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.email.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && $v.editForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.editForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.editForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="phone1">Telefon 1</label>
                <input
                    id="phone1"
                    type="text"
                    v-model="editForm.phone1"
                    class="form-control"
                    placeholder="Telefon numarası giriniz"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.phone1.$error,
                  }"
                    @blur="formatPhoneNumberEditFirst"
                    @input="filterNumbersPhoneEditFirst"
                />
                <div v-if="editSubmitted && $v.editForm.phone1.$error" class="invalid-feedback">
                  <span v-if="!$v.editForm.phone1.required">Telefon numarası 1 girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="phone2">Telefon 2</label>
                <input
                    id="phone2"
                    type="text"
                    v-model="editForm.phone2"
                    class="form-control"
                    placeholder="Telefon numarası giriniz"
                    @blur="formatPhoneNumberEditSecond"
                    @input="filterNumbersPhoneEditSecond"

                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="familyAddress">Aile Adresi</label>
                <input
                    id="familyAddress"
                    type="text"
                    v-model="editForm.familyAddress"
                    class="form-control"
                    placeholder="Aile Adresi giriniz"

                />

              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="familyPhone">Aile Telefonu</label>
                <input
                    id="familyPhone"
                    type="text"
                    v-model="editForm.familyPhone"
                    class="form-control"
                    placeholder="Aile Telefonu giriniz"
                    @blur="formatFamilyPhoneEdit"
                    @input="filterFamilyPhoneEdit"

                />
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="fatherName">Baba Adı</label>
                <input
                    name="fatherName"
                    id="fatherName"
                    type="text"
                    autocomplete="off"
                    v-model="editForm.fatherName"
                    class="form-control"
                    placeholder="Baba Adı giriniz"

                />

              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="motherName">Anne Adı</label>
                <input
                    name="motherName"
                    id="motherName"
                    type="text"
                    autocomplete="off"
                    v-model="editForm.motherName"
                    class="form-control"
                    placeholder="Anne Adı giriniz"

                />

              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="birthdate">Doğum Tarihi</label>
                <b-form-input
                    v-model="editForm.birthdate"
                    id="birthdate"
                    type="date"

                ></b-form-input>

              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="birthplace">Doğum Yeri</label>
                <input
                    name="birthplace"
                    id="birthplace"
                    type="text"
                    autocomplete="off"
                    v-model="editForm.birthplace"
                    class="form-control"
                    placeholder="Doğum Yeri giriniz"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="site">Site Seçiniz</label>
                <select id="site" v-model="editForm._site" class="form-control" :class="{'is-invalid': editSubmitted && $v.editForm._site.$error}">
                  <option value="">Site Seçiniz</option>
                  <option v-for="site in sites" :key="site.id" :value="site.id">{{ site.name }}</option>
                </select>
              </div>
            </div>
            <div
                v-if="editFormError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ editFormError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Müşteri Düzenle</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu Müşteriyi silmek istediğinize emin misiniz? Silinmiş Müşteriları geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız Müşteriyi silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
.badge-soft-yellow {
  color: #000000;
  background-color: rgba(255, 255, 0, 0.85); }
</style>
